module.exports = __webpack_public_path__ + "img/icon-sort-light.346aab40.svg";